import React, {useState} from 'react'
import {productionLineReports} from "../../services/serviceReports";
import {Button, Card, Col, DatePicker, Row, Space, Table, Tag} from "antd";
import config from "../../config";
import userDateFormatter from "../../services/formatters/userDateFormatter";

const {RangePicker} = DatePicker

const setTableRowKeys = (r, index) => index

const ProductionLineReports = () => {
    const [tableData, setTableData] = useState([])
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()

    const columns = [
        {title: 'Üretim Hattı', dataIndex: 'pl'},
        {title: 'Reçete Kodu', dataIndex: 'rc'},
        {title: 'Reçete Adı', dataIndex: 'rn'},
        {title: 'Müşteri', dataIndex: 'cn'},
        {title: 'Üretim Adeti', dataIndex: 'q'},
        {title: 'Reçete Tarihi', dataIndex: 'rd', render: (t) => userDateFormatter(t)}
    ]

    const onDatesChange = (val) => {
        if (val) {
            const [start, end] = val
            setStartDate(start._d)
            setEndDate(end._d)
        }
    }

    const handleReport = () => {
        productionLineReports({
            startDate: startDate,
            endDate: endDate
        })
            .then(({data}) => reduceData(data))
    }

    const reduceData = (data) => {
        const tableSource = data.map((item, index) => {
            const dto = item.productionReportDTO
            return {
                key: index,
                q: dto.q,
                rc: dto.rc,
                cn: dto.cn,
                rd: dto.rd,
                pl: dto.pl,
                rn: dto.rn,
                recipeGainDTO: item.recipeGainDTO || []
            }
        })
        setTableData(tableSource)
    }

    const truncateBidString = (bidString) => {
        const truncated = bidString.replace(/{|}/g, '')
        const arr = truncated.split(',')
        return arr.slice(0,5).join(',')
    }

    const expandedRowRender = (record) => {
        const recipeItem = record.recipeGainDTO
        const localData = []
        if (recipeItem) {
            localData.push({
                key: `${record.key}-expand`,
                g: recipeItem.g || '-',
                a: recipeItem.a || '-',
                c: recipeItem.c || '-',
                bn: recipeItem.bn ? truncateBidString(recipeItem.bn) : '-'
            })
        }

        const localColumn = [
            {
                title: 'Kar / Zarar', dataIndex: 'g', key: 'g', render: (t) => Number(t) > 0 ? <Tag color={'green'}>{t}</Tag> : <Tag color={'red'} >{t}</Tag>
            },
            {
                title: 'Ortalama', dataIndex: 'a', key: 'a'
            },
            {
                title: 'Stok Kodu', dataIndex: 'c', key: 'c'
            },
            {
                title: 'Teklif No', dataIndex: 'bn', key: 'bn'
            }
        ]
        return (
            <React.Fragment>
                <Table className={'expanded-table'} scroll={{x: 'max-content'}} dataSource={localData} columns={localColumn} pagination={false}/>
            </React.Fragment>
        )
    }
    const rowExpandable = ({recipeGainDTO}) => recipeGainDTO.length || Object.keys(recipeGainDTO).length

    return(
        <React.Fragment>
            <Card
                title={'Üretim Hattı Raporları'}
            >
                <Space direction={"vertical"} size={'large'} style={{width: '100%'}}>
                    <Row gutter={32}>
                        <Col>
                            <RangePicker
                                onChange={onDatesChange}
                                format={config.userDateFormat}
                            />
                        </Col>
                        <Col>
                            <Button type={'primary'} onClick={handleReport}>
                                Gönder
                            </Button>
                        </Col>
                    </Row>
                    <Table
                        rowKey={setTableRowKeys}
                        columns={columns}
                        dataSource={tableData}
                        expandable={{
                            rowExpandable,
                            expandedRowRender
                        }}
                    />
                </Space>
            </Card>
        </React.Fragment>
    )
}
export default ProductionLineReports